import * as React from 'react';
import { createContext, useContext } from 'react';

import { CoachStateProvider } from 'bundles/unified-common/providers/CoachStateProvider';
import useIsDesktop from 'bundles/unified-description-page-common/hooks/useIsDesktop';
import { useMobileWebConversationalDiscoveryExperiment } from 'bundles/unified-description-page-common/providers/specialization/MobileWebConversationalDiscoveryExperimentProvider';
import { useTwoPanelConversationalDiscoveryExperiment } from 'bundles/unified-description-page-common/providers/specialization/TwoPanelConversationalDiscoveryProvider';

export type CoachCareerFitAssistantContextType = {
  coachCareerFitAssistantEnabled: boolean;
};

export const CoachCareerFitAssistantContext = createContext<CoachCareerFitAssistantContextType>({
  coachCareerFitAssistantEnabled: false,
});

function CoachCareerFitAssistantProvider({ children }: React.PropsWithChildren) {
  const { twoPanelConversationalDiscoveryEnabled } = useTwoPanelConversationalDiscoveryExperiment();
  const { mobileWebConversationalDiscoveryEnabled } = useMobileWebConversationalDiscoveryExperiment();
  const isDesktop = useIsDesktop();

  // Two-panel replaces career-fit on desktop, the mobile tray off desktop -- suppress career-fit
  // exactly when whichever replacement is actually showing.
  const coachCareerFitAssistantEnabled =
    (!twoPanelConversationalDiscoveryEnabled || !isDesktop) && (!mobileWebConversationalDiscoveryEnabled || isDesktop);

  return (
    <CoachCareerFitAssistantContext.Provider
      value={{
        coachCareerFitAssistantEnabled,
      }}
    >
      {/* Keyed on the UA-stable flags, not the viewport-aware value above -- skips this wrapper
          when a replacement experience supplies its own forced-open CoachStateProvider. */}
      {!twoPanelConversationalDiscoveryEnabled && !mobileWebConversationalDiscoveryEnabled ? (
        <CoachStateProvider>{children}</CoachStateProvider>
      ) : (
        children
      )}
    </CoachCareerFitAssistantContext.Provider>
  );
}

export const useCoachCareerFitAssistantData = () => {
  return useContext(CoachCareerFitAssistantContext);
};

export default CoachCareerFitAssistantProvider;
